export class EconomyStatusBarValues {
    statusText = '';
    statusIndex: number = null;
    redIconIndex: number = null;
    warnIconIndex: number = null;
    redIconText = '';
}
